import React from 'react';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';
import deleteCustomFieldTemplate from '../../utils/api/delete/deleteCustomFieldTemplate';
import { reloadData } from '../../storage/actions/applicationStateActions';
import RowActions from '../dashboard/RowActions';

const ManageCustomFieldsActions = ({ toggleModal, item, reloadData }) => {
  const handleEdit = () => {
    toggleModal(true, 'addOrEditCustomFields', false, item);
  };

  const handleDelete = () => {
    deleteCustomFieldTemplate(item._id).then(() => reloadData());
  };

  return (
    <RowActions
      alignEnd
      onEdit={handleEdit}
      onDelete={handleDelete}
    />
  );
};

const mapDispatchToProps = {
  toggleModal,
  reloadData,
};

export default connect(null, mapDispatchToProps)(ManageCustomFieldsActions);
